Attributes of the closed position profile.
